const EVENTS = {
  DONATION_ERROR: "DONATION_ERROR",
  DONATION_FORM_INPUT_ERROR: "DONATION_FORM_INPUT_ERROR",
  DONATION_FORM_PAYMENT_ERROR: "DONATION_FORM_PAYMENT_ERROR",
  DONATION_FORM_PAYMENT_SUCCESS: "DONATION_FORM_PAYMENT_DATA",
  FLYOUT_OPEN: "FLYOUT_OPEN",
  FORM_SUBMITTED: "FORM_SUBMITTED",
  GALLERY_INTERACTION: "GALLERY_INTERACTION",
  CONTRAST: "CONTRAST",
  MENU_CLOSE: "MENU_CLOSE",
  MENU_OPEN: "MENU_OPEN",
  MODAL_OPEN: "MODAL_OPEN",
  MULTISELECT_RESET: "MULTISELECT_RESET",
  OVERLAY_INIT: "OVERLAY_INIT",
  RESIZED: "RESIZED",
  SCROLLED: "SCROLLED",
  VIEWPORT_CHANGED: "VIEWPORT_CHANGED",
  VISIBLE: "VISIBLE",
};

const STORAGE_KEYS = {
  SUPPORTER_NAME: "SUPPORTER_NAME",
  CONTRAST: "CONTRAST",
  MOTIVE_VARIANT: "MOTIVE_VARIANT",
};

const COOKIES = {
  CONTACT_FORM_START: "contact_form_start",
  CONTACT_FORM_SUBMISSION: "contact_form_submission",
  CONTACT_TESTAMENT_FORM_START: "contact_testament_form_start",
  CONTACT_TESTAMENT_FORM_SUBMISSION: "contact_testament_form_submission",
  CHANGE_ADDRESS_FORM_START: "change_address_form_start",
  CHANGE_ADDRESS_FORM_SUBMISSION: "change_address_form_submission",
  CHANGE_FUNDING_CONTRIBUTION_FORM_START:
    "change_funding_contribution_form_start",
  CHANGE_FUNDING_CONTRIBUTION_FORM_SUBMISSION:
    "change_funding_contribution_form_submission",
  ADD_EMAIL_ADDRESS_FORM_START: "add_email_address_form_start",
  ADD_EMAIL_ADDRESS_FORM_SUBMISSION: "add_email_address_form_submission",
  CHANGE_BANK_DETAILS_FORM_START: "change_bank_details_form_start",
  CHANGE_BANK_DETAILS_FORM_SUBMISSION: "change_bank_details_form_submission",
  DONATION_ENTRY_POINT: "donation_entry_point",
  DONATION_PURCHASE: "donation_purchase",
  DONATION_START: "donation_start",
  DONATION_VERIFICATION: "donation_verification",
  GIFT_DONATION_FORM_NAME: "gift_donation_form",
  MATERIAL_PURCHASE: "material_purchase",
  MATERIAL_START: "material_start",
  MATERIAL_VERIFICATION: "material_verification",
  PAYPAL_ERROR: "paypal_error",
  PROMOTION_PURCHASE: "promotion_purchase",
  PROMOTION_START: "promotion_start",
  PROMOTION_VERIFICATION: "promotion_verification",
  SELECTED_MOTIVE: "selected_motiv",
};

/* viewports are also defined in src/css/common/tokens.css for css viewport handling */
const VIEWPORTS = {
  S: "(max-width: 35.5625em)",
  M: "(min-width: 35.625em) and (max-width: 59.9375em)",
  L: "(min-width: 60em) and (max-width: 79.9375em)",
  XL: "(min-width: 80em)",
};

export { COOKIES, EVENTS, STORAGE_KEYS, VIEWPORTS };
